export default __webpack_public_path__ + "static/media/sc10.1141cb86.png";